import { ResourceType } from "@common/types/auditLog";
import { HistoryRow } from "../../views/historyViewConfig";

// Discriminator + id selection for routing a workspace Activity row to the CoA
// template apply-event drawer. Kept pure (no React) so both the drawer and the
// context provider can share it and it stays trivially testable.
type ApplyEventRow = Pick<HistoryRow, "resourceType">;

export function isCoaTemplateApplyEventRow(
    row: ApplyEventRow | null | undefined,
): boolean {
    return row?.resourceType === ResourceType.chartOfAccountsTemplateApplyEvent;
}
